module.exports = __webpack_public_path__ + "static/media/rocket-badge-big.a6c37b91.svg";